import TextField from '@elentari/components-eve/final-form/TextField'
import { useSnackbar } from '@elentari/core'
import { useEntitySaver } from '@elentari/core/hooks/useEntitySaver'
import { Grid } from '@material-ui/core'
import { isNil } from 'ramda'
import { useEffect } from 'react'
import { useLocation } from 'react-router-dom'
import { AnexoInput } from 'src/components/AnexoInput'
import api from 'src/services/api'
import * as yup from 'yup'
import ComplexDialog from '../../../../components/ComplexDialog'
import { MessagesYup } from '../../../../modules/messages'
import yupValidation from '../../../../utils/yupValidation'
import { candidatosDocumentosRepository } from './hooks/documentosAdminRepository'
import { useCandidatoDocumento } from './hooks/useCandidatoDocumento'
import { SaveAnexoProcessoSeletivoAdministrativoDocumentoInput } from './types'

type Props = {
  idDocumento: string | null
  idCandidato: string | null
  open: boolean
  handleClose: () => void
  fetchData: () => void
}

export const AnexoCandidatoDocumentoForm = ({
  idDocumento,
  idCandidato,
  open,
  handleClose,
  fetchData
}: Props) => {
  const [anexoCandidatoDocumentoState, anexoCandidatoDocumentoAction] =
    useCandidatoDocumento()
  const [, snackbarActions] = useSnackbar()
  const location = useLocation()
  const processoId = location.pathname.split('/')[2]

  const dialogSchema = yup.object().shape({
    descricao: yup
      .string()
      .trim()
      .required(MessagesYup.MENSAGEM_OBRIGATORIO)
      .typeError(MessagesYup.MENSAGEM_OBRIGATORIO),
    anexo: yup.object().when('URL', {
      is: (URL: string) => isNil(URL),
      then: yup.object().required(MessagesYup.MENSAGEM_OBRIGATORIO)
    })
  })

  const { saveWithoutRedirect } =
    useEntitySaver<SaveAnexoProcessoSeletivoAdministrativoDocumentoInput>(
      async data => {
        const response = await candidatosDocumentosRepository.save(data)
        return response
      }
    )

  const handleSubmit = async (
    data: SaveAnexoProcessoSeletivoAdministrativoDocumentoInput
  ) => {
    try {
      if (data.anexo) {
        const responseS3 = await api.saveUploadS3({ file: data.anexo })
        if (responseS3) {
          data.URL = responseS3.info.url
        }
      }

      delete data.anexo

      if (idCandidato) data.candidatoId = idCandidato
      data.origemDocumento = 'GESTOR_PROCESSO_SELETIVO'
      data.processoSeletivoAdminId = processoId
      await saveWithoutRedirect(data)
      fetchData()
    } catch (error: any) {
      snackbarActions.setMessage(error.message)
    }
  }

  useEffect(() => {
    async function fetchAnexo() {
      if (idDocumento && idDocumento !== 'new') {
        await anexoCandidatoDocumentoAction.fetch(idDocumento)
      }
    }

    fetchAnexo()
  }, [idDocumento])

  useEffect(() => {
    return anexoCandidatoDocumentoAction.reset()
  }, [anexoCandidatoDocumentoAction, open])

  return (
    <ComplexDialog
      open={open}
      title={'Insira as informações do Anexo'}
      handleClose={handleClose}
      primaryAction={handleSubmit}
      validate={yupValidation(dialogSchema)}
      initialValues={
        anexoCandidatoDocumentoState.tag === 'with-data' && {
          id: anexoCandidatoDocumentoState.entity.id,
          descricao: anexoCandidatoDocumentoState.entity.descricao,
          URL: anexoCandidatoDocumentoState.entity.URL
        }
      }
      disableBackdropClick={true}
    >
      <Grid container spacing={2}>
        <Grid item xs={12}>
          <TextField
            fullWidth
            name="descricao"
            label="Descrição do Documento"
          />
        </Grid>
        <Grid item xs={12}>
          <AnexoInput name="anexo" />
        </Grid>
      </Grid>
    </ComplexDialog>
  )
}
